import { useEffect, useState } from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { getStoredConsent, saveConsent, SETTINGS_EVENT } from '@/lib/consent';

// Aviso de cookies: aparece na primeira visita e some depois da escolha.
// O visitante pode reabri-lo pelo link "Preferências de cookies" no rodapé.
const CookieBanner = () => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(() => getStoredConsent() === null);

  useEffect(() => {
    const open = () => setVisible(true);
    window.addEventListener(SETTINGS_EVENT, open);
    return () => window.removeEventListener(SETTINGS_EVENT, open);
  }, []);

  if (!visible) return null;

  const choose = (choice) => {
    saveConsent(choice);
    setVisible(false);
  };

  return (
    <div
      role="region"
      aria-label={t('cookies.title')}
      className="fixed inset-x-0 bottom-0 z-[60] p-4 pointer-events-none"
      data-testid="cookie-banner"
    >
      <div className="pointer-events-auto mx-auto max-w-3xl rounded-xl border border-[#C5A059]/30 bg-[#101B2D] p-5 text-white shadow-2xl flex flex-col gap-4 sm:flex-row sm:items-center">
        <p className="flex-1 text-sm leading-relaxed text-gray-200">{t('cookies.text')}</p>
        <div className="flex gap-3 sm:flex-shrink-0">
          <button
            type="button"
            onClick={() => choose('denied')}
            className="h-10 flex-1 rounded-lg border border-gray-500 px-5 text-sm font-bold text-gray-200 transition-colors hover:bg-white/10 sm:flex-none"
            data-testid="cookie-refuse"
          >
            {t('cookies.refuse')}
          </button>
          <button
            type="button"
            onClick={() => choose('granted')}
            className="h-10 flex-1 rounded-lg px-5 btn-gold text-sm font-bold sm:flex-none"
            data-testid="cookie-accept"
          >
            {t('cookies.accept')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
